// ----------------------- Action types ----------------------------
export const CHANGE_ACTIVE_ITEM_TS_EXPERT = "CH_TS_EXPERT";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
// ----------------------- Protocol ----------------------------
export const CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME = "CH_RESUME";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST = "CH_LIVELIST";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX = "CH_LIVELIST_MATRIX";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY = "CH_GRAPHIC_TOPOLOGY";
export const CHANGE_ACTIVE_ITEM_PROTOCOL_LOG = "CH_LOG";
// ----------------------- Optic Fiber ----------------------------
export const CHANGE_ACTIVE_ITEM_OPTIC_FIBER = "CH_OPTIC";
export const CHANGE_ACTIVE_ITEM_OPTIC_FIBER_LOG = "CH_OPTIC_LOG";
// ----------------------- Physical Medium DP ----------------------------
export const CHANGE_ACTIVE_ITEM_DP_LIVELIST = "CH_DP_LIVELIST";
export const CHANGE_ACTIVE_ITEM_DP_LIVELIST_MATRIX = "CH_DP_LIVELIST_MATRIX";
export const CHANGE_ACTIVE_ITEM_DP_OSCILLOSCOPE = "CH_DP_OSC";
export const CHANGE_ACTIVE_ITEM_DP_BAR_GRAPH = "CH_DP_BAR_GRAPH";
export const CHANGE_ACTIVE_ITEM_DP_LOG = "CH_DP_LOG";
// ----------------------- Solve Problem ----------------------------
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";
// ----------------------- Change Route ----------------------------
export const CHANGE_ROUTE = "CH_ROUTE";